import { render, staticRenderFns } from "./ItemInformation.vue?vue&type=template&id=726fc218"
import script from "./ItemInformation.vue?vue&type=script&lang=ts"
export * from "./ItemInformation.vue?vue&type=script&lang=ts"
import style0 from "./ItemInformation.vue?vue&type=style&index=0&id=726fc218&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports